import { get } from "../../utils/object-helpers";

<if(input)>
    $ {
        const title = get(input, 'title', {});
        const subTitles = get(input, 'subTitles.0', {});
        const className = 'str-top-rated-seller';
    }
    <section class=className>
        <str-textual-display ...title class=`${className}__title` />
        <str-textual-display class=`${className}__subtitle` ...subTitles/>
    </section>
</if>
